<template>
    <div class="tab-pane fade" :class="{'show active': current_step === 1, 'loading': loading}" id="luminaire-selection-step" role="tabpanel" aria-labelledby="luminaire-selection-step-tab">
        <form action="" @submit.prevent>
            <div class="accordion md-accordion pt-4" id="lst-accordion" role="tablist" aria-multiselectable="true">
                <!-- Accordion cards for Selection Steps -->
                <div class="card lst-steps" v-for="(luminaire_selection_step, lssIndex) in luminaire_selection_steps">
                    <!-- Card header -->
                    <div class="card-header px-0 py-3" role="tab" :id="'heading-' + luminaire_selection_step.id" :class="(luminaire_selection_step.product_attribute_name in lstForm && lstForm[luminaire_selection_step.product_attribute_name]) ? 'valid-step' : 'not-valid-step'">
                        <a data-toggle="collapse" data-parent="#lst-accordion" :href="'#lst-step-' + luminaire_selection_step.order" :aria-expanded="lssIndex === 0 ? 'true' : 'false'" :aria-controls="'lst-step-' + luminaire_selection_step.order" :class="{ 'collapsed' : lssIndex > 0 }">
                            <h4 class="m-0 text-white d-flex justify-content-between">
                                <span>{{ $t(luminaire_selection_step.title) }} <i class="fas fa-check-circle text-primary" v-if="luminaire_selection_step.product_attribute_name in lstForm && lstForm[luminaire_selection_step.product_attribute_name]"></i></span> <i class="fas fa-chevron-down rotate-icon text-primary"></i>
                            </h4>
                        </a>
                    </div>
                    <!-- Card body -->
                    <div :id="'lst-step-' + luminaire_selection_step.order" :class="['collapse', { 'show' : lssIndex === 0 }]" role="tabpanel" :aria-labelledby="'heading-lst-step-' + luminaire_selection_step.order" data-parent="#lst-accordion">
                        <div class="card-body px-0 py-3">
                            <div class="container-fluid px-0">
                                <ul class="list-unstyled row">
                                    <!-- normal selection step options -->
                                    <template v-for="(luminaire_selection_option, lsoIndex) in filteredLstOptions">
                                        <li class="col-12 pb-2"
                                            v-if="luminaire_selection_option.luminaire_selection_step_id === luminaire_selection_step.id && isFirstIndividualOptic(luminaire_selection_option, lsoIndex)"
                                            :key="`separator-${luminaire_selection_option.id}-${lsoIndex}`">
                                            <hr class="individual-optics-separator">
                                            <p class="text-light text-center small mb-2">{{ $t('Individual optics (clip-on)') }}</p>
                                        </li>

                                        <li class="col-6 col-sm-4 pb-4"
                                            v-if="luminaire_selection_option.luminaire_selection_step_id === luminaire_selection_step.id"
                                            :key="`option-${luminaire_selection_option.id}-${lsoIndex}`">
                                            <div class="custom-control custom-radio image-checkbox" :class="'lst-step-' + luminaire_selection_step.id + '-option-' + lsoIndex">
                                                <input
                                                    v-if="!isOptionDisabled(luminaire_selection_option.id)"
                                                    :checked="Number(lstForm[luminaire_selection_step.product_attribute_name]) === Number(luminaire_selection_option.id)"
                                                    :value="luminaire_selection_option.id"
                                                    @change="onLstOptionChange(luminaire_selection_step, luminaire_selection_option.id, $event)"
                                                    type="radio"
                                                    class="custom-control-input"
                                                    :id="'lst-step-' + luminaire_selection_step.id + '-option-' + lsoIndex"
                                                    :name="'lst-step-' + luminaire_selection_step.id + '-options'">
                                                <label
                                                    class="custom-control-label w-100" :for="'lst-step-' + luminaire_selection_step.id + '-option-' + lsoIndex"
                                                    :class="{ 'disabled-luminaire-selection-option':isOptionDisabled(luminaire_selection_option.id) }">
                                                    <img
                                                        :src="asset('lst/' + ( $i18n.locale === 'en' && luminaire_selection_option.picture_file_name_en ? luminaire_selection_option.picture_file_name_en : luminaire_selection_option.picture_file_name))"
                                                        alt="#"
                                                        class="img-fluid w-100"
                                                        v-if="luminaire_selection_option.picture_file_name"
                                                        :class="{'no-click': luminaire_selection_option.id === 16}">
                                                    <p class="text-white text-center pt-2 mb-0" v-if="luminaire_selection_option.title"><strong>{{ $t( luminaire_selection_option.title ) }}</strong> <i class="fas fa-info-circle text-primary" data-toggle="tooltip" :title="$t( luminaire_selection_option.tooltip )" v-if="luminaire_selection_option.tooltip"></i></p>
                                                    <p class="text-light text-center pt-1 mb-0 small" v-if="luminaire_selection_option.description">{{ $t( luminaire_selection_option.description ) }}</p>
                                                </label>
                                            </div>
                                        </li>
                                    </template>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Accordion card -->
                <div>
                    <download-dialux-data-button
                        v-if="false && lstForm.led_module_serie_id && lstForm.led_module_optics_id && lstForm.led_module_power_id && lstForm.led_module_color_rendering_index_id && lstForm.led_module_color_temperature_id"
                        :product_configurator_id="product_configurator_id"
                        :plannings="[lstForm]"
                        :generatedSku="generatedSku"
                        :button_class="'btn-outline-primary'"
                        @update-loading="updateLoading" />

                    <download-tender-text-button
                        v-if="validatedSteps.includes(1)"
                        :product_configurator_id="product_configurator_id"
                        :planning_data="lstForm"
                        :planning_id="0"
                        :button_class="'btn-outline-primary'"
                        @update-loading="updateLoading" />
                </div>
            </div>
        </form>
    </div>
</template>

<script>

    import { mapGetters } from 'vuex';

    const INDIVIDUAL_OPTIC_PARTIAL_SKUS = ['01', '10', '11'];
    const INCOMPATIBLE_COLOR_TEMP_PARTIAL_SKUS_FOR_INDIVIDUAL_OPTICS = ['27', '30', '65']; // Partial SKUs
    const INCOMPATIBLE_CRI_FOR_INDIVIDUAL_OPTICS = ['90']; // Ra90
    const INCOMPATIBLE_TEMPERATURE_FOR_INDIVIDUAL_OPTICS = ['70']; // 70°

    const STATIC_DISABLED_OPTION_IDS = [16, 13, 4];

    // IP55 availability rules (must stay aligned with StorePlanningRequest backend validation).
    const IP55_ALLOWED_SERIE_IDS = [1, 44, 2, 42, 43];
    const IP55_ALLOWED_COMBINED_OPTICS_IDS = [41, 6, 5];

    const IP55_DISALLOWED_POWER_PARTIAL_SKUS = ['15'];
    const IP55_ALLOWED_HOUSING_COLOR_PARTIAL_SKUS = ['00'];
    const IP55_ALLOWED_COLOR_TEMP_PARTIAL_SKUS = ['40', '50'];
    const IP55_ALLOWED_CRI_PARTIAL_SKUS = ['80'];
    const IP55_ALLOWED_CONTROL_PARTIAL_SKUS_BY_SERIE_ID = {
        1: ['00', '01'],
        44: ['00', '01'],
        2: ['00'],
        42: ['00', '01'],
        43: ['00', '01'],
    };
    const IP55_ALLOWED_AMBIENT_PARTIAL_SKUS = ['50', '70'];
    const IP55_NORMALIZATION_FIELDS = [
        'led_module_optics_id',
        'led_module_power_id',
        'led_module_housing_color_id',
        'led_module_color_temperature_id',
        'led_module_color_rendering_index_id',
        'led_module_ambient_temperature_id',
        'led_module_control_id',
    ];

    export default {
        props: [
            'current_step',
            'product_configurator_id',
            'validatedSteps',
            'editPlanning',
            'existingSku',
            'ledModuleConfiguration'
        ],
        data() {
            return {
                loading: true,
                lstForm: {
                    led_module_name: '',
                },
                luminaire_selection_steps: [],
                luminaire_selection_options: [],
                filteredLstOptions: [],

                disabledOptionIds: [...STATIC_DISABLED_OPTION_IDS],

                stepOneValidated: false,
                selectedOptions: [],
                selectedSerie: '',
                selectedControl: '',
                selectedHousingColor: '',
                selectedOptics: '',
                selectedProtectionClass: '',

                calculatedProductPrice: '',
                generatedSku: '',
                generatedProductName: '',
                // Last stable selection snapshot used to rollback canceled IP55 normalization.
                lastCommittedLstForm: null,
                // Prevent parent update emissions while a user change transaction is unresolved.
                suppressLstFormWatcherEmit: false,

                dataLoaded: false,

                luminaireLineProducts: {
                    mountingRails: [],
                    blindModules: [],
                    electricalFeeds: [],
                    mountConnectors: [],
                    suspensions: [],
                    mountingAdapter: [],
                    emergency_lights: [],
                    luminaire_controls: [],
                    cable_routes: [],
                    mounting_adapter_tools: [],
                    universal_adapters: [],
                    optics: [],
                },

            }
        },

        methods: {

            cloneLstForm(form) {
                if (!form || typeof form !== 'object') {
                    return { led_module_name: '' };
                }

                return JSON.parse(JSON.stringify(form));
            },

            commitLstFormState() {
                this.lastCommittedLstForm = this.cloneLstForm(this.lstForm);
            },

            emitLstFormSnapshot(form = this.lstForm) {
                this.$emit('update-lst-form', form);
                this.emitIndividualOpticFlag();
            },

            syncLstRadioCheckedState() {
                if (!Array.isArray(this.luminaire_selection_steps) || this.luminaire_selection_steps.length === 0) {
                    return;
                }

                this.luminaire_selection_steps.forEach(step => {
                    if (!step || !step.id || !step.product_attribute_name) {
                        return;
                    }

                    const selectedOptionId = Number(this.lstForm[step.product_attribute_name] || 0);
                    const radioName = `lst-step-${step.id}-options`;
                    document.querySelectorAll(`input[type="radio"][name="${radioName}"]`).forEach(input => {
                        const radioValue = Number(input.value || 0);
                        input.checked = !!selectedOptionId && radioValue === selectedOptionId;
                    });
                });
            },

            restoreLstFormSnapshot(snapshot) {
                if (!snapshot) {
                    return;
                }

                this.lstForm = this.cloneLstForm(snapshot);
                this.filterLstOptions();
                this.setSelectedOptions();
            },

            restoreLastCommittedLstForm() {
                this.restoreLstFormSnapshot(this.lastCommittedLstForm);
            },

            escapeSwalHtml(value) {
                return String(value == null ? '' : value)
                    .replace(/&/g, '&amp;')
                    .replace(/</g, '&lt;')
                    .replace(/>/g, '&gt;')
                    .replace(/"/g, '&quot;')
                    .replace(/'/g, '&#39;');
            },

            updateLoading(value) {
                this.$emit('update-loading', value);
            },

            emitIndividualOpticFlag() {
                const opticsId = this.lstForm.led_module_optics_id;
                const option = this.luminaire_selection_options.find(o => o.id === Number(opticsId));
                const partial = option ? option.partial_sku : null;
                const isIndividual = INDIVIDUAL_OPTIC_PARTIAL_SKUS.includes(partial);
                this.$emit('update-individual-optic-selected', isIndividual);
                this.$emit('update-selected-optics-partial', partial || null);
            },

            /**************************************************************************
             * LOAD DATA
             **************************************************************************/

            loadLuminaireSelectionSteps() {

                 axios.get('/api/luminaire_selection_steps/' + this.product_configurator_id)
                    .then((response) => {
                        this.luminaire_selection_steps = response.data.data;

                        if (!this.editPlanning && this.luminaire_selection_options && this.luminaire_selection_options.length > 0) {
                            this.$emit('update-loading', false);
                        }
                    })
                    .catch(function(error) {
                        console.log(error);
                    });

            },

            loadLuminaireSelectionOptions() {

                axios.get('/api/luminaire_selection_options/' + this.product_configurator_id)
                    .then((response) => {
                        this.luminaire_selection_options = response.data.data;
                        this.filterLstOptions();

                        // Ensure IP40 is default for protection class if nothing selected
                        if (!this.editPlanning) {
                            this.setDefaultProtectionClassIP40();
                            if (!this.lastCommittedLstForm) {
                                this.commitLstFormState();
                            }
                        }

                        if (!this.editPlanning && this.luminaire_selection_steps && this.luminaire_selection_steps.length > 0) {
                            this.$emit('update-loading', false);
                        } else {
                            this.setLedConfiguration();
                        }
                    })
                    .catch(function(error) {
                        console.log(error);
                        if (!this.editPlanning) {
                            this.$emit('update-loading', false);
                        }
                    });
                this.loading = false;

            },

            setDefaultProtectionClassIP40() {
                try {
                    // Only set default if not already selected
                    if (this.lstForm && this.lstForm.led_module_protection_class_id) return;
                    if (!this.luminaire_selection_steps || this.luminaire_selection_steps.length === 0) return;
                    if (!this.luminaire_selection_options || this.luminaire_selection_options.length === 0) return;

                    const protectionStep = this.luminaire_selection_steps.find(s => s.product_attribute_name === 'led_module_protection_class_id');
                    if (!protectionStep) return;

                    const ip40 = this.luminaire_selection_options.find(o => o.luminaire_selection_step_id === protectionStep.id && o.partial_sku === '40' && o.enabled);
                    if (!ip40) return;

                    this.lstForm.led_module_protection_class_id = ip40.id;
                    this.setSelectedOptions();
                } catch (e) {
                    // noop
                }
            },

            /**************************************************************************
             * PROCESS FORM
             **************************************************************************/

            // Build preview state from committed form because v-model already mutated lstForm
            // before @change handlers run.
            buildCandidateLstForm(stepAttr, optionId) {
                const baseForm = this.lastCommittedLstForm
                    ? this.cloneLstForm(this.lastCommittedLstForm)
                    : this.cloneLstForm(this.lstForm);

                baseForm[stepAttr] = optionId;

                return baseForm;
            },

            isIp55NormalizationGateRequired(stepAttr, optionId, committedForm) {
                const selectingIp55 =
                    stepAttr === 'led_module_protection_class_id'
                    && Number(optionId) === 15;
                const changingSerieWhileIp55 =
                    stepAttr === 'led_module_serie_id'
                    && Number(committedForm?.led_module_protection_class_id) === 15;

                return selectingIp55 || changingSerieWhileIp55;
            },

            getSelectionDisplayValue(optionId) {
                if (!optionId) {
                    return '-';
                }

                const option = this.luminaire_selection_options.find(
                    item => item.id === Number(optionId)
                );

                if (!option) {
                    return String(optionId);
                }

                return option.title ? this.$t(option.title) : (option.partial_sku || String(option.id));
            },

            getIp55NormalizationFieldLabel(productAttributeName) {
                const step = this.getStepByAttributeName(productAttributeName);
                if (step && step.title) {
                    return this.$t(step.title);
                }

                return productAttributeName;
            },

            computeNormalizedIp55State(candidateForm) {
                const normalizedForm = this.cloneLstForm(candidateForm);
                this.normalizeIp55SelectionsOnForm(normalizedForm);

                return normalizedForm;
            },

            // Compare candidate user state with its normalized IP55 state to build a confirm-dialog delta.
            computeIp55NormalizationDelta(candidateForm) {
                // Keep preview and runtime in sync by reusing the same normalization function.
                const normalizedForm = this.computeNormalizedIp55State(candidateForm);
                const changes = [];

                IP55_NORMALIZATION_FIELDS.forEach(field => {
                    const fromValue = candidateForm[field] || null;
                    const toValue = normalizedForm[field] || null;

                    if (Number(fromValue || 0) === Number(toValue || 0)) {
                        return;
                    }

                    changes.push({
                        field,
                        label: this.getIp55NormalizationFieldLabel(field),
                        from: this.getSelectionDisplayValue(fromValue),
                        to: this.getSelectionDisplayValue(toValue),
                    });
                });

                return {
                    hasChanges: changes.length > 0,
                    changes,
                };
            },

            buildIp55NormalizationSummaryHtml(changes) {
                const rows = changes.map(change => (
                    '<div style="margin:0 0 8px 0;">'
                    + '<strong>'
                    + this.escapeSwalHtml(change.label)
                    + '</strong>: '
                    + this.escapeSwalHtml(change.from)
                    + ' &rarr; '
                    + this.escapeSwalHtml(change.to)
                    + '</div>'
                ));

                return '<div style="max-width:360px;margin:0 auto;text-align:left;">'
                    + '<p style="margin:0 0 12px 0;color:#393e42;">'
                    + this.escapeSwalHtml(this.$t('This will change:'))
                    + '</p>'
                    + rows.join('')
                    + '</div>';
            },

            async confirmIp55Normalization(changes) {
                const result = await this.$swal.fire({
                    title: this.$t('Apply IP55 changes?'),
                    html: this.buildIp55NormalizationSummaryHtml(changes),
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3CA2A4',
                    cancelButtonColor: '#393e42',
                    confirmButtonText: this.$t('Apply'),
                    cancelButtonText: this.$t('Cancel'),
                });

                return !!(result && (result.value || result.isConfirmed));
            },

            applyLstSelectionAndRecompute(step, optionId, event) {
                if (!step || !step.product_attribute_name) {
                    return;
                }

                // Single commit path for actual state changes after the selection pipeline runs.
                this.lstForm[step.product_attribute_name] = optionId;
                this.goToNextSection(event, step.order);
                this.filterLstOptions();
                this.setSelectedOptions();
                // Explicit commit keeps snapshot fresh even if internal guards skip commit in setSelectedOptions.
                this.commitLstFormState();
            },

            // Handle one user option change as a transaction: evaluate gate, confirm if needed,
            // then either commit recomputation or rollback to the last committed snapshot.
            async onLstOptionChange(step, optionId, event) {
                if (!step || !step.product_attribute_name) {
                    return;
                }

                let emitLstFormAfterTransaction = true;
                let rollbackSnapshot = null;
                // Block deep watcher emissions until confirm/cancel transaction is resolved.
                this.suppressLstFormWatcherEmit = true;

                const stepAttr = step.product_attribute_name;
                const committedForm = this.lastCommittedLstForm
                    ? this.cloneLstForm(this.lastCommittedLstForm)
                    : this.cloneLstForm(this.lstForm);
                const candidateForm = this.buildCandidateLstForm(stepAttr, optionId);
                const gateRequired = this.isIp55NormalizationGateRequired(stepAttr, optionId, committedForm);

                try {
                    if (!gateRequired) {
                        this.applyLstSelectionAndRecompute(step, optionId, event);
                        return;
                    }

                    const delta = this.computeIp55NormalizationDelta(candidateForm);
                    if (!delta.hasChanges) {
                        this.applyLstSelectionAndRecompute(step, optionId, event);
                        return;
                    }

                    const confirmed = await this.confirmIp55Normalization(delta.changes);
                    if (confirmed) {
                        this.applyLstSelectionAndRecompute(step, optionId, event);
                        return;
                    }

                    rollbackSnapshot = committedForm;
                    emitLstFormAfterTransaction = false;
                } finally {
                    // Wait one tick so all reactive mutations settle before re-enabling watcher emissions.
                    await this.$nextTick();
                    if (rollbackSnapshot) {
                        // Apply rollback after v-model event updates have settled so cancel wins deterministically.
                        this.restoreLstFormSnapshot(rollbackSnapshot);
                        await this.$nextTick();
                    }
                    this.suppressLstFormWatcherEmit = false;
                    if (emitLstFormAfterTransaction) {
                        this.emitLstFormSnapshot();
                    }
                }
            },

            validateStepOne() {

                let step_1_validated = false;

                // Validate Step 1 - if all steps -> then validated
                let step_1_validated_counter = 0;

                this.luminaire_selection_steps.forEach( lstStep => {
                    if ( this.lstForm[lstStep.product_attribute_name] ) {
                        step_1_validated_counter++;
                    }
                });

                if ( step_1_validated_counter < this.luminaire_selection_steps.length || step_1_validated_counter > this.luminaire_selection_steps.length ) {
                    step_1_validated = 'step_1_not_valid';
                    this.allLuminaireSelectionStepsSelected = false;
                    // Set allLuminaireSelectionStepsSelected to false
                    this.$emit('update-all-luminaire-selection-steps-selected', false);
                } else {
                    step_1_validated = 'step_1_valid';
                    // Set allLuminaireSelectionStepsSelected to true
                    this.$emit('update-all-luminaire-selection-steps-selected', true);
                    this.allLuminaireSelectionStepsSelected = true;
                }

                console.log('Step One Validated:', this.allLuminaireSelectionStepsSelected);

                this.stepOneValidated = step_1_validated;

            },

            setSelectedOptions() {
                let selectedOptions = [];

                if (this.product_configurator_id
                    && this.lstForm
                    && this.luminaire_selection_options && this.luminaire_selection_options.length > 0
                    && this.luminaire_selection_steps && this.luminaire_selection_steps.length > 0) {

                    this.checkProtectionClass();

                    for (const [key, value] of Object.entries(this.lstForm)) {
                        if (key !== 'led_module_name' && value != null) {
                            const matchingOption = this.luminaire_selection_options.find(
                                option => Number(option.id) === Number(value)
                            );

                            // Clear old saved option ids that are no longer available,
                            // like the removed 15W power value.
                            if (!matchingOption || !matchingOption.enabled) {
                                this.lstForm[key] = null;
                                continue;
                            }

                            selectedOptions.push(matchingOption);
                        }
                    }

                    // sort selectedOptions array by Luminaire Selection Step Order
                    selectedOptions.sort((a,b) => {
                        if(a.luminaire_selection_step.order < b.luminaire_selection_step.order) return -1;
                        if(a.luminaire_selection_step.order > b.luminaire_selection_step.order) return 1;
                        return 0;
                    });


                    this.selectedOptions = selectedOptions;

                    if (this.editPlanning) {
                        this.$emit('update-loading', false);
                    }

                    this.$emit('update-selected-options', selectedOptions);
                    this.loading = false;

                    this.checkIfSelectedOptionsAreValid();
                    this.commitLstFormState();
                    this.$nextTick(() => {
                        this.syncLstRadioCheckedState();
                    });

                }


            },

            updateLedConfigurations() {

                if ( this.lstForm.led_module_serie_id === 1 || this.lstForm.led_module_serie_id === 44  ) {
                    this.selectedSerie = 'eco';
                } else if ( this.lstForm.led_module_serie_id === 2 ) {
                    this.selectedSerie = 'max_10';
                } else if ( this.lstForm.led_module_serie_id === 42 ) {
                    this.selectedSerie = 'max_12';
                } else if ( this.lstForm.led_module_serie_id === 43 ) {
                    this.selectedSerie = 'max_14';
                } else {
                    this.selectedSerie = '';
                }

                if (this.lstForm.led_module_control_id) {
                    this.selectedControl = this.lstForm.led_module_control_id;
                } else {
                    this.selectedControl = '';
                }

                if (this.lstForm.led_module_housing_color_id) {
                    this.selectedHousingColor = this.lstForm.led_module_housing_color_id;
                } else {
                    this.selectedHousingColor = '';
                }

                if (this.lstForm.led_module_optics_id) {
                    this.selectedOptics = this.lstForm.led_module_optics_id;
                } else {
                    this.selectedOptics = '';
                }

                if (this.lstForm.led_module_protection_class_id) {
                    this.checkProtectionClass();
                    this.selectedProtectionClass = this.lstForm.led_module_protection_class_id;
                } else {
                    this.selectedProtectionClass = '';
                }

                this.generateSku();
            },

            generateSku() {

                let generatedSku = '';

                if (this.selectedOptions.length === this.luminaire_selection_steps.length) {
                    generatedSku = '';
                    for (const [key, value] of Object.entries(this.selectedOptions)) {
                        generatedSku = generatedSku + value.partial_sku;
                    }
                }
                this.generatedSku = generatedSku;
            },

            generateProductName() {

                if (!this.luminaire_selection_steps && !this.luminaire_selection_options) return;

                let generatedProductName = '';
                let productTitle = '';
                let productPower = '';

                if (this.selectedOptions.length > 0 && this.selectedOptions.find(item => item.luminaire_selection_step_id === 1) ) {
                    // if Serie is selected
                    productTitle = 'tempLED ' + this.selectedOptions.find(item => item.luminaire_selection_step_id === 1).title;
                }

                // if Leistung is selected
                if (this.selectedOptions.length > 0 && this.selectedOptions.find(item => item.luminaire_selection_step_id === 8) ) {
                    productPower = this.selectedOptions.find(item => item.luminaire_selection_step_id === 8).title;
                }

                if ( productTitle.length > 0 ) {
                    generatedProductName = this.$t(productTitle, 'de') + ' ' + this.$t(productPower, 'de');
                }

                this.lstForm.led_module_name = generatedProductName;

                this.generatedProductName = generatedProductName;

            },

            checkProtectionClass () {
                try {
                    const protectionClassId = Number(this.lstForm.led_module_protection_class_id);

                    // IP44 cleanup needs to run before returning from non-IP55 flows.
                    if (protectionClassId === 46) {
                        this.normalizeIp44SelectionsIfNeeded();
                    }

                    if (protectionClassId !== 15) {
                        return;
                    }

                    // Run IP55 cleanup first, then decide whether we must fall back.
                    this.normalizeIp55SelectionsIfNeeded();

                    const { serie_id, optics_id } = this.getCurrentSelections();
                    const ip55Ctx = this.buildIp55Context(serie_id, optics_id);

                    if (ip55Ctx.shouldDisableIp55) {
                        this.fallbackProtectionClassFromIp55(ip55Ctx.protectionStep);
                    }
                } catch (e) {
                    // noop
                }
            },

            /**************************************************************************
             * EDIT
             **************************************************************************/

            setLedConfiguration() {

                if (!this.product_configurator_id || !this.ledModuleConfiguration || !this.luminaire_selection_options || !this.luminaire_selection_options) {
                    return;
                }

                this.lstForm = this.ledModuleConfiguration;
                this.clearStoredSelectionsThatNoLongerExist();

                // Apply filters immediately after setting the configuration
                // This is important for edit mode to validate existing selections
                this.filterLstOptions();

                this.setSelectedOptions();
                if (!this.lastCommittedLstForm) {
                    this.commitLstFormState();
                }

            },



            /**************************************************************************
             * GENERAL
             **************************************************************************/

            isFirstIndividualOptic(option, index) {
                if (!this.filteredLstOptions || option.luminaire_selection_step_id !== 3 || !this.isIndividualOptic(option)) {
                    return false;
                }

                const priorOptics = this.filteredLstOptions
                    .slice(0, index)
                    .filter(o => o.luminaire_selection_step_id === 3);

                return !priorOptics.some(o => this.isIndividualOptic(o));
            },

            isIndividualOptic(option) {
                return !!(option && option.partial_sku && INDIVIDUAL_OPTIC_PARTIAL_SKUS.includes(option.partial_sku));
            },

            isIndividualOpticId(opticsId) {
                if (!opticsId) {
                    return false;
                }

                const option = this.luminaire_selection_options.find(o => o.id === Number(opticsId));
                return this.isIndividualOptic(option);
            },

            isIncompatibleColorTemp(option) {
                return !!(option && option.partial_sku && INCOMPATIBLE_COLOR_TEMP_PARTIAL_SKUS_FOR_INDIVIDUAL_OPTICS.includes(option.partial_sku));
            },

            isIncompatibleColorTempId(colorTempId) {
                if (!colorTempId) {
                    return false;
                }

                const option = this.luminaire_selection_options.find(o => o.id === Number(colorTempId));
                return this.isIncompatibleColorTemp(option);
            },

            // CRI incompatibility helpers (match by partial_sku only)
            isIncompatibleCri(option) {
                // Compare strictly by partial_sku; constants contain partial SKUs
                if (!option) return false;
                const partial = option.partial_sku;
                return !!(partial && INCOMPATIBLE_CRI_FOR_INDIVIDUAL_OPTICS.includes(partial));
            },

            isIncompatibleCriId(criId) {
                if (!criId) {
                    return false;
                }
                const option = this.luminaire_selection_options.find(o => o.id === Number(criId));
                return this.isIncompatibleCri(option);
            },

            // Ambient temperature incompatibility helpers (match by partial_sku only)
            isIncompatibleAmbientTemperature(option) {
                // Compare strictly by partial_sku; constants contain partial SKUs
                if (!option) return false;
                const partial = option.partial_sku;
                return !!(partial && INCOMPATIBLE_TEMPERATURE_FOR_INDIVIDUAL_OPTICS.includes(partial));
            },

            isIncompatibleAmbientTemperatureId(ambientTempId) {
                if (!ambientTempId) {
                    return false;
                }
                const option = this.luminaire_selection_options.find(o => o.id === Number(ambientTempId));
                return this.isIncompatibleAmbientTemperature(option);
            },

            isOptionDisabled(optionId) {
                return this.disabledOptionIds
                    .map(id => Number(id))
                    .includes(Number(optionId));
            },

            activateTooltips () {
                $( document ).ready(function() {
                    setTimeout(function() {
                        $('[data-toggle="tooltip"]').tooltip();
                    }, 2000);
                });
            },

            goToNextSection: function (event, lssOrder) {
                lssOrder++;
                $('#lst-step-' + lssOrder + '.collapse').collapse('show');
            },

            /**
             * Check if URL has a specific parameter
             * @param {string} paramName - The parameter name to check for
             * @param {string} [valueToMatch] - Optional specific value to match
             * @returns {boolean|string} - True if parameter exists with matching value, or the parameter value if valueToMatch is null
             */
            hasUrlParam(paramName, valueToMatch = null) {
                const urlParams = new URLSearchParams(window.location.search);
                if (!valueToMatch) {
                    if (urlParams.has(paramName)) {
                        return urlParams.get(paramName) || true;
                    }
                    return false;
                }
                return urlParams.has(paramName) && urlParams.get(paramName) === valueToMatch;
            },

            checkIfSelectedOptionsAreValid() {
                const isValid = this.selectedOptions.every(option => {
                        return this.filteredLstOptions.some(filteredOption => filteredOption.id === option.id)
                    }
                );

                if (!isValid) {
                    this.unsetInvalidSelectedOptions();
                }

                return isValid;
            },

            unsetInvalidSelectedOptions() {
                this.selectedOptions = this.selectedOptions.filter(option =>
                    this.filteredLstOptions.some(filteredOption => filteredOption.id === option.id)
                );

                // Update lstForm to remove invalid options
                for (const step of this.luminaire_selection_steps) {
                    if (!this.selectedOptions.some(option => option.luminaire_selection_step_id === step.id)) {
                        // Remove the option from selectedOptions & lstForm
                        this.selectedOptions = this.selectedOptions.filter(selectedOption => selectedOption.luminaire_selection_step_id !== step.id);
                        this.lstForm[step.product_attribute_name] = null;

                    }
                }
            },

            // -------------------------------
            // Filtering helpers
            // -------------------------------
            getStepByAttributeName(productAttributeName) {
                return this.luminaire_selection_steps.find(
                    step => step.product_attribute_name === productAttributeName
                );
            },

            getOptionsByStepAttribute(productAttributeName) {
                const step = this.getStepByAttributeName(productAttributeName);
                if (!step) {
                    return [];
                }

                return this.luminaire_selection_options.filter(
                    option => option.luminaire_selection_step_id === step.id
                );
            },

            clearStoredSelectionsThatNoLongerExist() {
                if (!this.lstForm || !Array.isArray(this.luminaire_selection_options)) {
                    return;
                }

                Object.keys(this.lstForm).forEach(field => {
                    if (field === 'led_module_name') {
                        return;
                    }

                    const selectedId = Number(this.lstForm[field] || 0);
                    if (!selectedId) {
                        return;
                    }

                    const matchingOption = this.luminaire_selection_options.find(
                        option => Number(option.id) === selectedId
                    );

                    // Old saved projects can still point to options that no longer exist,
                    // like the removed 15W power entry. Clear them so the missing step is visible.
                    if (!matchingOption || !matchingOption.enabled) {
                        this.lstForm[field] = null;
                    }
                });
            },

            getEnabledOptionsByStepAttribute(productAttributeName) {
                return this.getOptionsByStepAttribute(productAttributeName)
                    .filter(option => option.enabled);
            },

            getSelectedOptionByAttribute(productAttributeName, sourceForm = this.lstForm) {
                const selectedOptionId = sourceForm[productAttributeName];
                if (!selectedOptionId) {
                    return null;
                }

                return this.luminaire_selection_options.find(
                    option => option.id === Number(selectedOptionId)
                ) || null;
            },

            findFirstEnabledOptionByStepAttribute(productAttributeName, matcher = () => true) {
                return this.getEnabledOptionsByStepAttribute(productAttributeName).find(matcher) || null;
            },

            findFirstEnabledOptionById(productAttributeName, optionId) {
                return this.findFirstEnabledOptionByStepAttribute(
                    productAttributeName,
                    option => option.id === Number(optionId)
                );
            },

            getCurrentSelections() {
                return {
                    ambient_temp_id: this.lstForm.led_module_ambient_temperature_id,
                    color_temp_id: this.lstForm.led_module_color_temperature_id,
                    serie_id: this.lstForm.led_module_serie_id,
                    optics_id: this.lstForm.led_module_optics_id,
                };
            },

            applySerieSpecificFiltering(options, serie_id) {
                // If Max 10-pole is selected (serie_id === 2), hide DALI ('01') and CLO ('11') for step 9
                if (serie_id === 2) {
                    return options.filter(el => {
                        if (el.luminaire_selection_step_id === 9) {
                            return el.partial_sku !== '01' && el.partial_sku !== '11';
                        }
                        return true;
                    });
                }
                return options;
            },

            applyAmbient70Filtering(options, ambient_temp_id) {
                if (ambient_temp_id === 35) {
                    options = options.filter(el => el.id !== 30);
                    options = options.filter(el => el.id !== 33);
                    options = options.filter(el => el.id !== 34);
                    options = options.filter(el => el.id !== 45);
                }
                return options;
            },

            applyColorTempCriConstraint(options, color_temp_id) {
                // If Color temperature is not 4000 (ID 9) or 5000 (ID 10) then remove Ra90 (ID 12)
                if (color_temp_id !== 9 && color_temp_id !== 10) {
                    return options.filter(el => el.id !== 12);
                }
                return options;
            },

            isIp55DisallowedPower(option) {
                return !!(option && IP55_DISALLOWED_POWER_PARTIAL_SKUS.includes(option.partial_sku));
            },

            isIp55AllowedHousingColor(option) {
                return !!(option && IP55_ALLOWED_HOUSING_COLOR_PARTIAL_SKUS.includes(option.partial_sku));
            },

            isIp55AllowedColorTemp(option) {
                return !!(option && IP55_ALLOWED_COLOR_TEMP_PARTIAL_SKUS.includes(option.partial_sku));
            },

            isIp55AllowedCri(option) {
                return !!(option && IP55_ALLOWED_CRI_PARTIAL_SKUS.includes(option.partial_sku));
            },

            getIp55ControlAllowlist(serieId = null) {
                const normalizedSerieId = Number(serieId ?? this.lstForm.led_module_serie_id);
                return IP55_ALLOWED_CONTROL_PARTIAL_SKUS_BY_SERIE_ID[normalizedSerieId] || ['00', '01'];
            },

            isIp55AllowedControl(option, serieId = null) {
                const allowlist = this.getIp55ControlAllowlist(serieId);
                return !!(option && allowlist.includes(option.partial_sku));
            },

            isIp55AllowedAmbient(option) {
                return !!(option && IP55_ALLOWED_AMBIENT_PARTIAL_SKUS.includes(option.partial_sku));
            },

            isIp55AllowedCombinedOpticId(opticsId) {
                return IP55_ALLOWED_COMBINED_OPTICS_IDS.includes(Number(opticsId));
            },

            /**
             * Build one context object used by disable and fallback logic.
             * This keeps all "is IP55 possible right now?" checks in one place.
             */
            buildIp55Context(serie_id, optics_id) {
                const protectionStep = this.getStepByAttributeName('led_module_protection_class_id');
                const individualOpticOptions = this.getOptionsByStepAttribute('led_module_optics_id')
                    .filter(option => this.isIndividualOptic(option));
                const isIp55Selected = Number(this.lstForm.led_module_protection_class_id) === 15;
                const isValidSerieForIP55 = IP55_ALLOWED_SERIE_IDS.includes(Number(serie_id));
                const hasAnyValidCombinedOptics = this.getEnabledOptionsByStepAttribute('led_module_optics_id')
                    .some(option => this.isIp55AllowedCombinedOpticId(option.id));
                const shouldDisableIp55 = !isValidSerieForIP55 || !hasAnyValidCombinedOptics;

                return {
                    protectionStep,
                    individualOpticOptions,
                    isIp55Selected,
                    shouldDisableIp55,
                    isValidOpticsForIP55: this.isIp55AllowedCombinedOpticId(optics_id),
                };
            },

            /**
             * IP55 may only fall back when it is fundamentally impossible
             * (unsupported series or no valid combined optics available).
             */
            fallbackProtectionClassFromIp55(protectionStep = null) {
                const resolvedProtectionStep = protectionStep || this.getStepByAttributeName('led_module_protection_class_id');
                if (!resolvedProtectionStep) {
                    this.lstForm.led_module_protection_class_id = null;
                    return;
                }

                const isIndividualOptic = this.isIndividualOpticId(this.lstForm.led_module_optics_id);
                const ip40 = this.luminaire_selection_options.find(
                    option =>
                        option.luminaire_selection_step_id === resolvedProtectionStep.id
                        && option.partial_sku === '40'
                        && option.enabled
                );
                const ip44 = isIndividualOptic ? null : this.luminaire_selection_options.find(
                    option =>
                        option.luminaire_selection_step_id === resolvedProtectionStep.id
                        && option.partial_sku === '44'
                        && option.enabled
                );

                this.lstForm.led_module_protection_class_id = ip40 ? ip40.id : (ip44 ? ip44.id : null);
            },

            /**
             * Resolve invalid IP44 + individual-optics states without user intervention.
             * Fallback order mirrors IP55: Opal -> Batwing -> Intense; then IP40.
             */
            normalizeIp44SelectionsIfNeeded() {
                if (Number(this.lstForm.led_module_protection_class_id) !== 46) {
                    return;
                }

                if (!this.isIndividualOpticId(this.lstForm.led_module_optics_id)) {
                    return;
                }

                const fallbackOptics = [41, 6, 5]
                    .map(opticsId => this.findFirstEnabledOptionById('led_module_optics_id', opticsId))
                    .find(option => !!option);

                if (fallbackOptics) {
                    this.lstForm.led_module_optics_id = fallbackOptics.id;
                    return;
                }

                const protectionStep = this.getStepByAttributeName('led_module_protection_class_id');
                const ip40 = protectionStep
                    ? this.luminaire_selection_options.find(
                        option =>
                            option.luminaire_selection_step_id === protectionStep.id
                            && option.partial_sku === '40'
                            && option.enabled
                    )
                    : null;

                this.lstForm.led_module_protection_class_id = ip40 ? ip40.id : null;
            },

            /**
             * Clean up only currently-selected invalid fields to valid IP55 values.
             * This preserves "IP55 is controlling" semantics without forcing unrelated changes.
             */
            normalizeIp55SelectionsOnForm(targetForm) {
                if (Number(targetForm.led_module_protection_class_id) !== 15) {
                    return;
                }

                const selectedOptics = this.getSelectedOptionByAttribute('led_module_optics_id', targetForm);
                const hasSelectedOptics = !!targetForm.led_module_optics_id;
                const hasValidSelectedOptics =
                    selectedOptics
                    && selectedOptics.enabled
                    && this.isIp55AllowedCombinedOpticId(selectedOptics.id)
                    && !this.isIndividualOptic(selectedOptics);

                if (hasSelectedOptics && !hasValidSelectedOptics) {
                    // Fallback order: Opal -> Batwing -> Intense.
                    const fallbackOptics = IP55_ALLOWED_COMBINED_OPTICS_IDS
                        .map(opticsId => this.findFirstEnabledOptionById('led_module_optics_id', opticsId))
                        .find(option => !!option);

                    if (fallbackOptics) {
                        targetForm.led_module_optics_id = fallbackOptics.id;
                    }
                }

                const selectedPower = this.getSelectedOptionByAttribute('led_module_power_id', targetForm);
                if (targetForm.led_module_power_id && (!selectedPower || this.isIp55DisallowedPower(selectedPower))) {
                    const fallbackPower = this.findFirstEnabledOptionByStepAttribute(
                        'led_module_power_id',
                        option => !this.isIp55DisallowedPower(option)
                    );
                    if (fallbackPower) {
                        targetForm.led_module_power_id = fallbackPower.id;
                    }
                }

                const selectedHousingColor = this.getSelectedOptionByAttribute('led_module_housing_color_id', targetForm);
                if (targetForm.led_module_housing_color_id && (!selectedHousingColor || !this.isIp55AllowedHousingColor(selectedHousingColor))) {
                    const fallbackHousingColor = this.findFirstEnabledOptionByStepAttribute(
                        'led_module_housing_color_id',
                        option => this.isIp55AllowedHousingColor(option)
                    );
                    if (fallbackHousingColor) {
                        targetForm.led_module_housing_color_id = fallbackHousingColor.id;
                    }
                }

                const selectedColorTemp = this.getSelectedOptionByAttribute('led_module_color_temperature_id', targetForm);
                if (targetForm.led_module_color_temperature_id && (!selectedColorTemp || !this.isIp55AllowedColorTemp(selectedColorTemp))) {
                    const fallbackColorTemp =
                        this.findFirstEnabledOptionByStepAttribute(
                            'led_module_color_temperature_id',
                            option => option.partial_sku === '40'
                        ) || this.findFirstEnabledOptionByStepAttribute(
                            'led_module_color_temperature_id',
                            option => option.partial_sku === '50'
                        );

                    if (fallbackColorTemp) {
                        targetForm.led_module_color_temperature_id = fallbackColorTemp.id;
                    }
                }

                const selectedCri = this.getSelectedOptionByAttribute('led_module_color_rendering_index_id', targetForm);
                if (targetForm.led_module_color_rendering_index_id && (!selectedCri || !this.isIp55AllowedCri(selectedCri))) {
                    const fallbackCri = this.findFirstEnabledOptionByStepAttribute(
                        'led_module_color_rendering_index_id',
                        option => this.isIp55AllowedCri(option)
                    );
                    if (fallbackCri) {
                        targetForm.led_module_color_rendering_index_id = fallbackCri.id;
                    }
                }

                const selectedAmbient = this.getSelectedOptionByAttribute('led_module_ambient_temperature_id', targetForm);
                if (targetForm.led_module_ambient_temperature_id && (!selectedAmbient || !this.isIp55AllowedAmbient(selectedAmbient))) {
                    const fallbackAmbient =
                        this.findFirstEnabledOptionByStepAttribute(
                            'led_module_ambient_temperature_id',
                            option => option.partial_sku === '50'
                        ) || this.findFirstEnabledOptionByStepAttribute(
                            'led_module_ambient_temperature_id',
                            option => option.partial_sku === '70'
                        );

                    if (fallbackAmbient) {
                        targetForm.led_module_ambient_temperature_id = fallbackAmbient.id;
                    }
                }

                const selectedControl = this.getSelectedOptionByAttribute('led_module_control_id', targetForm);
                if (targetForm.led_module_control_id && (!selectedControl || !this.isIp55AllowedControl(selectedControl, targetForm.led_module_serie_id))) {
                    const allowedControlPartials = this.getIp55ControlAllowlist(targetForm.led_module_serie_id);
                    let fallbackControl = null;
                    for (const partialSku of allowedControlPartials) {
                        fallbackControl = this.findFirstEnabledOptionByStepAttribute(
                            'led_module_control_id',
                            option => option.partial_sku === partialSku
                        );
                        if (fallbackControl) {
                            break;
                        }
                    }

                    if (fallbackControl) {
                        targetForm.led_module_control_id = fallbackControl.id;
                    }
                }
            },

            normalizeIp55SelectionsIfNeeded() {
                this.normalizeIp55SelectionsOnForm(this.lstForm);
            },

            /**
             * Build incompatibility lists used by individual-optics disable/fallback rules.
             */
            buildIncompatibilityLists() {
                const colorTempStep = this.getStepByAttributeName('led_module_color_temperature_id');
                const incompatibleColorTempOptions = colorTempStep
                    ? this.luminaire_selection_options.filter(
                        option =>
                            option.luminaire_selection_step_id === colorTempStep.id
                            && this.isIncompatibleColorTemp(option)
                    )
                    : [];

                const criStep = this.getStepByAttributeName('led_module_color_rendering_index_id');
                const incompatibleCriOptions = criStep
                    ? this.luminaire_selection_options.filter(
                        option =>
                            option.luminaire_selection_step_id === criStep.id
                            && this.isIncompatibleCri(option)
                    )
                    : [];

                const ambientStep = this.getStepByAttributeName('led_module_ambient_temperature_id');
                const incompatibleAmbientTempOptions = ambientStep
                    ? this.luminaire_selection_options.filter(
                        option =>
                            option.luminaire_selection_step_id === ambientStep.id
                            && this.isIncompatibleAmbientTemperature(option)
                    )
                    : [];

                return { incompatibleColorTempOptions, incompatibleCriOptions, incompatibleAmbientTempOptions, criStep, ambientStep };
            },

            /**
             * If an individual optic conflicts with selected CCT/CRI/ambient values,
             * clean up to the nearest valid combination to keep the form submittable.
             */
            applyFallbacksIfNeeded(isIndividualOpticSelected, lists, ambient_temp_id, color_temp_id) {
                const { criStep, ambientStep } = lists;
                const initialIsIncompatibleColorTemp = this.isIncompatibleColorTempId(color_temp_id);
                const initialIsIncompatibleCri = this.isIncompatibleCriId(this.lstForm.led_module_color_rendering_index_id);
                const initialIsIncompatibleAmbient = this.isIncompatibleAmbientTemperatureId(ambient_temp_id);

                if (isIndividualOpticSelected && (initialIsIncompatibleColorTemp || initialIsIncompatibleCri || initialIsIncompatibleAmbient)) {
                    const opalOption = this.findFirstEnabledOptionById('led_module_optics_id', 41);
                    if (opalOption) {
                        this.lstForm.led_module_optics_id = opalOption.id;
                    }

                    let fallbackColorTemp = this.findFirstEnabledOptionByStepAttribute(
                        'led_module_color_temperature_id',
                        option => option.partial_sku === '40'
                    );
                    if (!fallbackColorTemp) {
                        fallbackColorTemp = this.findFirstEnabledOptionByStepAttribute(
                            'led_module_color_temperature_id',
                            option => !this.isIncompatibleColorTemp(option)
                        );
                    }
                    if (fallbackColorTemp) {
                        this.lstForm.led_module_color_temperature_id = fallbackColorTemp.id;
                    }

                    if (criStep) {
                        const fallbackCri = this.findFirstEnabledOptionByStepAttribute(
                            'led_module_color_rendering_index_id',
                            option => !this.isIncompatibleCri(option)
                        );
                        if (fallbackCri) {
                            this.lstForm.led_module_color_rendering_index_id = fallbackCri.id;
                        }
                    }

                    if (ambientStep) {
                        const fallbackAmbient = this.findFirstEnabledOptionByStepAttribute(
                            'led_module_ambient_temperature_id',
                            option => !this.isIncompatibleAmbientTemperature(option)
                        );
                        if (fallbackAmbient) {
                            this.lstForm.led_module_ambient_temperature_id = fallbackAmbient.id;
                        }
                    }
                }
            },

            /**
             * Collect all option IDs that must be disabled while IP55 is selected.
             * IDs are grouped by attribute to keep rule ownership explicit.
             */
            buildIp55DependentLists() {
                const opticsOptionIds = this.getOptionsByStepAttribute('led_module_optics_id')
                    .filter(option => !this.isIp55AllowedCombinedOpticId(option.id))
                    .map(option => option.id);
                const powerOptionIds = this.getOptionsByStepAttribute('led_module_power_id')
                    .filter(option => this.isIp55DisallowedPower(option))
                    .map(option => option.id);
                const housingColorOptionIds = this.getOptionsByStepAttribute('led_module_housing_color_id')
                    .filter(option => !this.isIp55AllowedHousingColor(option))
                    .map(option => option.id);
                const colorTempOptionIds = this.getOptionsByStepAttribute('led_module_color_temperature_id')
                    .filter(option => !this.isIp55AllowedColorTemp(option))
                    .map(option => option.id);
                const criOptionIds = this.getOptionsByStepAttribute('led_module_color_rendering_index_id')
                    .filter(option => !this.isIp55AllowedCri(option))
                    .map(option => option.id);
                const ambientOptionIds = this.getOptionsByStepAttribute('led_module_ambient_temperature_id')
                    .filter(option => !this.isIp55AllowedAmbient(option))
                    .map(option => option.id);
                const controlOptionIds = this.getOptionsByStepAttribute('led_module_control_id')
                    .filter(option => !this.isIp55AllowedControl(option, this.lstForm.led_module_serie_id))
                    .map(option => option.id);

                return {
                    opticsOptionIds,
                    powerOptionIds,
                    housingColorOptionIds,
                    colorTempOptionIds,
                    criOptionIds,
                    ambientOptionIds,
                    controlOptionIds,
                };
            },

            /**
             * Rebuild disabled options from scratch on each pass.
             * Rebuilding the full set avoids stale entries from incremental push/remove updates.
             */
            computeDisabledOptionIds(ip55Ctx, individualLists, ip55DependentLists) {
                const disabledSet = new Set(STATIC_DISABLED_OPTION_IDS);

                if (ip55Ctx.shouldDisableIp55) {
                    disabledSet.add(15);
                }

                const isIp44Selected = Number(this.lstForm.led_module_protection_class_id) === 46;
                const finalIsIndividualOptic = this.isIndividualOpticId(this.lstForm.led_module_optics_id);
                const finalIsIncompatibleColorTemp = this.isIncompatibleColorTempId(this.lstForm.led_module_color_temperature_id);
                const finalIsIncompatibleCri = this.isIncompatibleCriId(this.lstForm.led_module_color_rendering_index_id);
                const finalIsIncompatibleAmbient = this.isIncompatibleAmbientTemperatureId(this.lstForm.led_module_ambient_temperature_id);

                const shouldDisableIndividualOptics =
                    ip55Ctx.isIp55Selected
                    || isIp44Selected
                    || finalIsIncompatibleColorTemp
                    || finalIsIncompatibleCri
                    || finalIsIncompatibleAmbient;

                if (shouldDisableIndividualOptics) {
                    ip55Ctx.individualOpticOptions.forEach(option => disabledSet.add(option.id));
                }

                if (finalIsIndividualOptic) {
                    individualLists.incompatibleColorTempOptions.forEach(option => disabledSet.add(option.id));
                    individualLists.incompatibleCriOptions.forEach(option => disabledSet.add(option.id));
                    individualLists.incompatibleAmbientTempOptions.forEach(option => disabledSet.add(option.id));

                    // Individual optics are IP40-only.
                    disabledSet.add(46);
                    disabledSet.add(15);
                }

                if (ip55Ctx.isIp55Selected) {
                    Object.values(ip55DependentLists).forEach(optionIds => {
                        optionIds.forEach(optionId => disabledSet.add(optionId));
                    });
                }

                this.disabledOptionIds = Array.from(disabledSet);
            },

            /**
             * Apply list filters first, then clean up selected values,
             * and finally compute one disabled-option set.
             */
            filterLstOptions() {
                let options = this.luminaire_selection_options;

                const { ambient_temp_id, color_temp_id, serie_id, optics_id } = this.getCurrentSelections();

                // Basic option list filtering (pure filters)
                options = this.applySerieSpecificFiltering(options, serie_id);
                options = this.applyAmbient70Filtering(options, ambient_temp_id);
                options = this.applyColorTempCriConstraint(options, color_temp_id);

                try {
                    const lists = this.buildIncompatibilityLists();
                    const isIndividualOpticSelected = this.isIndividualOpticId(optics_id);

                    // Keep existing individual-optics fallback behavior.
                    this.applyFallbacksIfNeeded(isIndividualOpticSelected, lists, ambient_temp_id, color_temp_id);

                    if (Number(this.lstForm.led_module_protection_class_id) === 15) {
                        this.normalizeIp55SelectionsIfNeeded();
                    } else if (Number(this.lstForm.led_module_protection_class_id) === 46) {
                        this.normalizeIp44SelectionsIfNeeded();
                    }

                    // Re-evaluate IP55 availability after cleanup changed selections.
                    let normalizedSelections = this.getCurrentSelections();
                    let ip55Ctx = this.buildIp55Context(normalizedSelections.serie_id, normalizedSelections.optics_id);

                    if (ip55Ctx.isIp55Selected && ip55Ctx.shouldDisableIp55) {
                        this.fallbackProtectionClassFromIp55(ip55Ctx.protectionStep);
                        normalizedSelections = this.getCurrentSelections();
                        ip55Ctx = this.buildIp55Context(normalizedSelections.serie_id, normalizedSelections.optics_id);
                    }

                    const ip55DependentLists = this.buildIp55DependentLists();
                    this.computeDisabledOptionIds(ip55Ctx, lists, ip55DependentLists);
                } catch (e) {
                    // noop
                }

                this.filteredLstOptions = options;
            },

            /**
             * Handle different prefill modes based on URL parameter
             */
            handlePrefill() {
                if (!this.luminaire_selection_steps || !this.luminaire_selection_options ||
                    this.luminaire_selection_steps.length === 0 || this.luminaire_selection_options.length === 0) {
                    return;
                }

                // Check if there's an SKU parameter
                const skuParam = this.hasUrlParam('sku');
                if (skuParam && this.prefillFromSku(skuParam)) {
                    // If we successfully prefilled from SKU, return early
                    return;
                }

                // Otherwise handle regular prefill modes
                const prefillValue = this.hasUrlParam('prefill');

                switch(prefillValue) {
                    case '1':
                        // Select first option for each step
                        this.autoSelectFirstOptions();
                        break;
                    case 'random':
                        // Select random options for each step
                        this.autoSelectRandomOptions();
                        break;
                    case 'eco':
                        // First option for first step, random for others
                        this.autoSelectEcoOptions();
                        break;
                    case 'max':
                        // Random option (except first) for first step, random for others
                        this.autoSelectMaxOptions();
                        break;
                    default:
                        // Default to first options if value is not recognized
                        this.autoSelectFirstOptions();
                        break;
                }
            },

            /**
             * Prefill form based on SKU parameter
             * @param {string} sku - The SKU string (18 digits)
             * @returns {boolean} - True if prefill was successful, false otherwise
             */
            prefillFromSku(sku) {
                // Validate SKU is exactly 18 digits
                if (!sku || !/^\d{18}$/.test(sku)) {
                    console.log('Invalid SKU format. Must be exactly 18 digits.');
                    return false;
                }

                console.log(`Prefilling form from SKU: ${sku}`);

                // Split SKU into chunks of 2 digits
                const skuChunks = [];
                for (let i = 0; i < sku.length; i += 2) {
                    skuChunks.push(sku.substring(i, i + 2));
                }

                // Sort steps by order to ensure correct mapping
                const sortedSteps = [...this.luminaire_selection_steps].sort((a, b) => a.order - b.order);

                // Check if we have the right number of chunks for our steps
                if (skuChunks.length !== sortedSteps.length) {
                    console.log(`SKU chunks count (${skuChunks.length}) doesn't match steps count (${sortedSteps.length})`);
                    return false;
                }

                let allOptionsFound = true;

                // Map each chunk to its corresponding step
                sortedSteps.forEach((step, index) => {
                    const partialSku = skuChunks[index];

                    // Find the option with matching partial SKU for this step
                    const matchingOption = this.luminaire_selection_options.find(option =>
                        option.luminaire_selection_step_id === step.id &&
                        option.partial_sku === partialSku
                    );

                    if (matchingOption && !this.isOptionDisabled(matchingOption.id)) {
                        // Set the option in the form
                        this.lstForm[step.product_attribute_name] = matchingOption.id;
                    } else {
                        console.log(`No matching option found for step ${step.id} with partial SKU ${partialSku}`);
                        allOptionsFound = false;
                    }
                });

                if (allOptionsFound) {
                    // Update the form and trigger necessary updates
                    this.filterLstOptions();
                    this.setSelectedOptions();
                    return true;
                } else {
                    console.log('Some options could not be found. Falling back to default prefill.');
                    return false;
                }
            },

            /**
             * Auto-select the first available option for each luminaire selection step
             */
            autoSelectFirstOptions() {
                if (!this.luminaire_selection_steps || !this.luminaire_selection_options ||
                    this.luminaire_selection_steps.length === 0 || this.luminaire_selection_options.length === 0) {
                    console.log('Cannot auto-select options: Data not loaded yet');
                    return;
                }

                console.log('Auto-selecting first options for each step');

                // Process each step
                this.luminaire_selection_steps.forEach(step => {
                    // Find the first non-disabled option for this step
                    const options = this.filteredLstOptions.filter(
                        option => option.luminaire_selection_step_id === step.id
                    );

                    if (options.length > 0) {
                        // Find first non-disabled option
                        const firstValidOption = options.find(option => !this.isOptionDisabled(option.id));

                        if (firstValidOption) {
                            // Set the option in the form
                            this.lstForm[step.product_attribute_name] = firstValidOption.id;
                        }
                    }
                });

                // Update the form and trigger necessary updates
                this.setSelectedOptions();
            },

            /**
             * Auto-select random options for each luminaire selection step
             */
            autoSelectRandomOptions() {
                if (!this.luminaire_selection_steps || !this.luminaire_selection_options ||
                    this.luminaire_selection_steps.length === 0 || this.luminaire_selection_options.length === 0) {
                    console.log('Cannot auto-select random options: Data not loaded yet');
                    return;
                }

                console.log('Auto-selecting random options for each step');

                // Process each step
                this.luminaire_selection_steps.forEach(step => {
                    this.selectRandomOptionForStep(step);
                });

                // Update the form and trigger necessary updates
                this.setSelectedOptions();
            },

            /**
             * Select a random option for a specific step
             * @param {Object} step - The step to select a random option for
             * @param {Array} [excludeOptions] - Optional array of option IDs to exclude
             */
            selectRandomOptionForStep(step, excludeOptions = []) {
                // Find all valid options for this step
                let validOptions = this.filteredLstOptions
                    .filter(option => option.luminaire_selection_step_id === step.id)
                    .filter(option => !this.isOptionDisabled(option.id));

                // Exclude specific options if needed
                if (excludeOptions.length > 0) {
                    validOptions = validOptions.filter(option => !excludeOptions.includes(option.id));
                }

                if (validOptions.length > 0) {
                    // Select a random option from the valid options
                    const randomIndex = Math.floor(Math.random() * validOptions.length);
                    const randomOption = validOptions[randomIndex];

                    // Set the random option in the form
                    this.lstForm[step.product_attribute_name] = randomOption.id;
                }
            },

            /**
             * Auto-select options for 'eco' mode:
             * - First option for first step
             * - Random options for all other steps
             */
            autoSelectEcoOptions() {
                if (!this.luminaire_selection_steps || !this.luminaire_selection_options ||
                    this.luminaire_selection_steps.length === 0 || this.luminaire_selection_options.length === 0) {
                    console.log('Cannot auto-select eco options: Data not loaded yet');
                    return;
                }

                console.log('Auto-selecting eco options: first for first step, random for others');

                // Sort steps by order to ensure we get the first step correctly
                const sortedSteps = [...this.luminaire_selection_steps].sort((a, b) => a.order - b.order);

                // Process each step
                sortedSteps.forEach((step, index) => {
                    if (index === 0) {
                        // For the first step, select the first option
                        const options = this.filteredLstOptions.filter(
                            option => option.luminaire_selection_step_id === step.id
                        );

                        if (options.length > 0) {
                            // Find first non-disabled option
                            const firstValidOption = options.find(option => !this.isOptionDisabled(option.id));

                            if (firstValidOption) {
                                // Set the option in the form
                                this.lstForm[step.product_attribute_name] = firstValidOption.id;
                            }
                        }
                    } else {
                        // For all other steps, select a random option
                        this.selectRandomOptionForStep(step);
                    }
                });

                // Update the form and trigger necessary updates
                this.setSelectedOptions();
            },

            /**
             * Auto-select options for 'max' mode:
             * - Random option (except first) for first step
             * - Random options for all other steps
             */
            autoSelectMaxOptions() {
                if (!this.luminaire_selection_steps || !this.luminaire_selection_options ||
                    this.luminaire_selection_steps.length === 0 || this.luminaire_selection_options.length === 0) {
                    console.log('Cannot auto-select max options: Data not loaded yet');
                    return;
                }

                console.log('Auto-selecting max options: random (except first) for first step, random for others');

                // Sort steps by order to ensure we get the first step correctly
                const sortedSteps = [...this.luminaire_selection_steps].sort((a, b) => a.order - b.order);

                // Process each step
                sortedSteps.forEach((step, index) => {
                    if (index === 0) {
                        // For the first step, find all options
                        const options = this.filteredLstOptions.filter(
                            option => option.luminaire_selection_step_id === step.id
                        );

                        if (options.length > 0) {
                            // Find first non-disabled option to exclude
                            const firstValidOption = options.find(option => !this.isOptionDisabled(option.id));

                            if (firstValidOption) {
                                // Select a random option excluding the first one
                                this.selectRandomOptionForStep(step, [firstValidOption.id]);
                            } else {
                                // If no valid first option, just select any random option
                                this.selectRandomOptionForStep(step);
                            }
                        }
                    } else {
                        // For all other steps, select a random option
                        this.selectRandomOptionForStep(step);
                    }
                });

                // Update the form and trigger necessary updates
                this.setSelectedOptions();
            },

        },

        computed: {

            ...mapGetters({
                authenticated: 'auth/authenticated',
                user: 'auth/user',
                permissions: 'auth/permissions'
            }),

            checkForLuminaireControlReset () {
                if ( this.lstForm.led_module_control_id === 27 || this.lstForm.led_module_control_id === 28 || this.lstForm.led_module_control_id === 29 ) {
                    return true;
                } else {
                    return false;
                }
            },

        },

        mounted() {
            if (this.product_configurator_id === 1 && !this.dataLoaded) {
                this.loadLuminaireSelectionSteps();
                this.loadLuminaireSelectionOptions();
                this.activateTooltips();

                // Auto-select options if prefill or sku parameter is present
                if (this.hasUrlParam('prefill') || this.hasUrlParam('sku')) {
                    // Wait for data to be loaded before selecting options
                    setTimeout(() => {
                        this.handlePrefill();
                    }, 1000);
                }

                this.dataLoaded = true;
            }
        },

        watch: {
            // Watch for changes in the lstForm object
            lstForm: {
                handler (newVal, oldVal) {
                    // During transactional confirm/cancel we emit once manually after final state is known.
                    if (this.suppressLstFormWatcherEmit) {
                        return;
                    }

                    this.emitLstFormSnapshot(newVal);
                },
                deep: true
            },

            product_configurator_id: function(value) {
                if (!this.dataLoaded) {
                    this.loadLuminaireSelectionSteps();
                    this.loadLuminaireSelectionOptions();
                    this.activateTooltips();

                    // Auto-select options if prefill or sku parameter is present
                    if (this.hasUrlParam('prefill') || this.hasUrlParam('sku')) {
                        // Wait for data to be loaded before selecting options
                        setTimeout(() => {
                            this.handlePrefill();
                        }, 1000);
                    }

                    this.dataLoaded = true;
                }
            },

            selectedSerie: function(value) {
                this.$emit('update-selected-serie', value);
            },

            /*selectedControl: function(value) {
                this.checkForLuminaireControlReset();
            },*/

            luminaireLineProducts: {
                handler(val, oldVal){
                    this.$emit('update-luminaire-line-products', val);
                },
                deep: true
            },

            generatedProductName: function(value) {
                this.$emit('update-generated-product-name', value);
            },

            stepOneValidated: function(value) {
                this.$emit('update-step-1-validated', value);
            },

            selectedControl: function(value) {
                this.$emit('update-selected-control', value);
            },

            selectedHousingColor: function(value) {
                this.$emit('update-selected-housing-color', value);
            },

            selectedOptics: function(value) {
                this.$emit('update-selected-optics', value);
                this.emitIndividualOpticFlag();
            },

            selectedProtectionClass: function(value) {
                this.$emit('update-selected-protection-class', value);
            },

            selectedOpticsPartial: function(value) {
                this.$emit('update-selected-optics-partial', value);
            },

            selectedOptions: function(value) {
                this.updateLedConfigurations();
                this.generateSku();
                this.generateProductName();
                this.validateStepOne();

                this.$emit('update-selected-options', value);
            },

            calculatedProductPrice: function(value) {
                this.$emit('update-calculated-product-price', value);
            },

            checkForLuminaireControlReset: function(value) {
                this.$emit('update-luminaire-control-reset', value);
            },

            generatedSku: function(value) {
                this.$emit('update-generated-sku', value);
            },

            /*ledModuleConfiguration: function(value) {
                console.log('ledModuleConfiguration', this.ledModuleConfiguration, this.product_configurator_id);
                this.setLedConfiguration();
            },*/

        },
    }
</script>
